import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Tilde extends Component {
     constructor(props) {
          super(props);
          this.state = {
               id:props.id,
               checked:props.checked,
          };
     }

     componentWillReceiveProps(nextProps) {
          if(this.state.id !== nextProps.id || this.state.checked !== nextProps.checked){
               this.setState({
                    id:nextProps.id,
                    checked:nextProps.checked,
               });
          }
     }

     switch(){
          if(this.props.valueChanged && this.props.disabled == false){
               this.setState(
                    {checked:!this.state.checked},
                    ()=>this.props.valueChanged(this.state.id, this.state.checked)
               );
          }
     }

     render() {
          return (
               <React.Fragment>
               <input disabled={this.props.disabled} type="checkbox" name={"checkboxStar"+this.state.id} id={"checkboxStar"+this.state.id}  className="checkbox-star" checked={this.state.checked == true} onChange={ () => this.switch() }/>
               <label htmlFor={"checkboxStar"+this.state.id}>
               {
                    this.state.checked == true ?
                    <i className="fa fa-star" aria-hidden="true" style={{cursor:"Pointer", color:"gold"}}/>
                    :
                    <i className="fa fa-star-o" aria-hidden="true" style={{cursor:"Pointer"}}/>
               }
               </label>
               </React.Fragment>
          );
     }
}

export default Tilde;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Destacados/Tilde.js